<template>
    <div class="main-container-shipmentinfo">
        <div class="inner-container">
            <div class="confirm-container-main">
                <div class="close-shipment-info-container">
                    <svg
                        class="close-shipment-info"
                        @click="closeShipmentPopup"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M255.997 460.351c112.685 0 204.355-91.668 204.355-204.348S368.682 51.648 255.997 51.648c-112.68 0-204.348 91.676-204.348 204.355s91.668 204.348 204.348 204.348zm0-376.463c94.906 0 172.123 77.209 172.123 172.115 0 94.898-77.217 172.117-172.123 172.117-94.9 0-172.108-77.219-172.108-172.117-.001-94.906 77.207-172.115 172.108-172.115z"
                            fill="#32ccfe"
                        />

                        <path
                            d="M172.077 341.508a18.35 18.35 0 0 0 12.903 5.27c4.776 0 9.54-1.84 13.151-5.512l57.865-58.973 57.878 58.973a18.372 18.372 0 0 0 13.146 5.512c4.658 0 9.316-1.746 12.902-5.27 7.264-7.125 7.369-18.793.242-26.051l-58.357-59.453 58.357-59.461c7.127-7.258 7.021-18.92-.242-26.047-7.252-7.123-18.914-7.018-26.049.24l-57.878 58.971-57.865-58.971c-7.135-7.264-18.797-7.363-26.055-.24-7.258 7.127-7.369 18.789-.236 26.047l58.351 59.461-58.351 59.453c-7.131 7.258-7.02 18.926.238 26.051z"
                            fill="#32ccfe"
                        />
                    </svg>
                </div>

                <div class="confirm-header-container">
                    <h1 class="package-details-header">
                        Create Shipment
                    </h1>

                    <img
                        src="../../../assets/LREXDinoFooter.jpg"
                        alt="LREX"
                    >
                </div>

                <div class="inner-overflow-container">
                    <div class="form-section">
                        <div class="section-header">
                            <h2>Shipment Information</h2>
                        </div>

                        <div class="form-grid">
                            <div class="input-container">
                                <label>Username *</label>

                                <input
                                    v-model.trim="shipmentInput.username"
                                    disabled
                                    type="text"
                                    placeholder="Username"
                                >
                            </div>

                            <div class="input-container">
                                <label>Account Number *</label>

                                <input
                                    v-model.trim="shipmentInput.accountNo"
                                    disabled
                                    type="text"
                                    placeholder="Account Number"
                                >
                            </div>

                            <div class="input-container">
                                <label>Service *</label>

                                <label class="override-option">
                                    <input
                                        v-model="overrideServiceOptions"
                                        type="checkbox"
                                        :disabled="gettingUserPreferences"
                                    />
                                    Override available services
                                </label>

                                <select
                                    v-model="shipmentInput.service"
                                    :disabled="gettingUserPreferences"
                                >
                                    <option disabled value="">
                                        {{
                                            gettingUserPreferences
                                                ? "Loading services..."
                                                : "Select Service"
                                        }}
                                    </option>

                                    <option
                                        v-for="productFamily in displayedServiceOptions"
                                        :key="productFamily"
                                        :value="productFamily"
                                    >
                                        {{ formatProductFamily(productFamily) }}
                                    </option>
                                </select>
                            </div>

                            <!-- <div class="input-container">
                                <label>Service *</label>

                                <select
                                    v-model="shipmentInput.service"
                                    :disabled="gettingUserPreferences"
                                >
                                    <option disabled value="">
                                        {{
                                            gettingUserPreferences
                                                ? "Loading services..."
                                                : "Select Service"
                                        }}
                                    </option>

                                    <option
                                        v-for="productFamily in serviceOptions"
                                        :key="productFamily"
                                        :value="productFamily"
                                    >
                                        {{ formatProductFamily(productFamily) }}
                                    </option>
                                </select>
                            </div> -->
                            

                            <div class="input-container">
                                <label>Weight *</label>

                                <input
                                    v-model.number="shipmentInput.weight"
                                    type="number"
                                    min="1"
                                    step="0.01"
                                    placeholder="Weight"
                                >
                            </div>

                            <!-- <div class="input-container">
                                <label>Package Count</label>

                                <input
                                    v-model.number="shipmentInput.packageCount"
                                    type="number"
                                    min="1"
                                    step="1"
                                    placeholder="Package Count"
                                >
                            </div> -->

                            <div class="input-container">
                                <label>Reference 1</label>

                                <input
                                    v-model.trim="shipmentInput.ref1"
                                    type="text"
                                    placeholder="Reference 1"
                                >
                            </div>

                            <div class="input-container">
                                <label>Reference 2</label>

                                <input
                                    v-model.trim="shipmentInput.ref2"
                                    type="text"
                                    placeholder="Reference 2"
                                >
                            </div>

                            <div class="input-container">
                                <label>Reference 3</label>

                                <input
                                    v-model.trim="shipmentInput.ref3"
                                    type="text"
                                    placeholder="Reference 3"
                                >
                            </div>

                            <div class="input-container">
                                <label>Reference 4</label>

                                <input
                                    v-model.trim="shipmentInput.ref4"
                                    type="text"
                                    placeholder="Reference 4"
                                >
                            </div>

                            <div class="input-container">
                                <label>Reference 5</label>

                                <input
                                    v-model.trim="shipmentInput.ref5"
                                    type="text"
                                    placeholder="Reference 5"
                                >
                            </div>

                            <div class="input-container full-width">
                                <label>Description</label>

                                <textarea
                                    v-model.trim="shipmentInput.description"
                                    maxlength="50"
                                    placeholder="Shipment description"
                                />
                            </div>

                            <div class="input-container full-width">
                                <label>Delivery Instructions</label>

                                <textarea
                                    v-model.trim="shipmentInput.deliveryInstructions"
                                    maxlength="50"
                                    placeholder="Delivery instructions"
                                />
                            </div>
                        </div>

                    </div>

                    <div class="form-section">
                        <div class="section-header">
                            <h2>Service Address</h2>
                        </div>

                        <div class="auto-complete-container">
                            <AWSAutoComplete
                                :placeHolder="'Search for the service address'"
                                @GetSelectedAddressData="setServiceAddress"
                                @customAddressToggle="customAddressToggle"
                            />
                        </div>

                        <AddressFields
                            v-model:address="shipmentInput.serviceAddress.address"
                        />

                        <div class="address-form-grid">
                            <div class="input-container">
                                <label>Company or Name</label>

                                <input
                                    v-model.trim="shipmentInput.serviceAddress.address.companyName"
                                    type="text"
                                    placeholder="Company or Name"
                                >
                            </div>

                            <div class="input-container">
                                <label>Attention</label>

                                <input
                                    v-model.trim="shipmentInput.serviceAddress.address.attention"
                                    type="text"
                                    placeholder="Attention"
                                >
                            </div>

                            <div class="input-container full-width">
                                <label>Address *</label>

                                <input
                                    v-model.trim="shipmentInput.serviceAddress.address.address1"
                                    type="text"
                                    placeholder="Address"
                                >
                            </div>

                            <div class="input-container full-width">
                                <label>Suite or Building</label>

                                <input
                                    v-model.trim="shipmentInput.serviceAddress.address.address2"
                                    type="text"
                                    placeholder="Suite or Building"
                                >
                            </div>

                            <div class="input-container">
                                <label>City *</label>

                                <input
                                    v-model.trim="shipmentInput.serviceAddress.address.city"
                                    type="text"
                                    placeholder="City"
                                >
                            </div>

                            <div class="input-container">
                                <label>State *</label>

                                <select
                                    v-model="shipmentInput.serviceAddress.address.state"
                                >
                                    <option disabled value="">
                                        Select State
                                    </option>

                                    <option
                                        v-for="state in stateOptions"
                                        :key="state"
                                        :value="state"
                                    >
                                        {{ state }}
                                    </option>
                                </select>
                            </div>

                            <div class="input-container">
                                <label>Zip Code *</label>

                                <input
                                    v-model.trim="shipmentInput.serviceAddress.address.zipCode"
                                    type="text"
                                    placeholder="Zip Code"
                                >
                            </div>

                            <div class="input-container">
                                <label>Phone</label>

                                <input
                                    v-model.trim="shipmentInput.serviceAddress.address.phone"
                                    type="tel"
                                    placeholder="Phone"
                                >
                            </div>

                            <div class="input-container">
                                <label>Phone Extension</label>

                                <input
                                    v-model.trim="shipmentInput.serviceAddress.address.phoneExt"
                                    type="text"
                                    placeholder="Extension"
                                >
                            </div>

                        </div>
                    </div>

                    <div class="swap-address-container">
                        <button
                            type="button"
                            class="swap-address-button"
                            :disabled="loadingData"
                            @click="swapAddresses"
                        >
                            ⇅ Swap Service and Pickup Addresses
                        </button>
                    </div>

                    <div
                        class="form-section"
                    >
                        <div class="section-header">
                            <h2>Pickup Address</h2>
                        </div>

                        <div class="auto-complete-container">
                            <AWSAutoComplete
                                :placeHolder="'Search for the pickup address'"
                                @GetSelectedAddressData="setPickupAddress"
                                @customAddressToggle="customAddressToggle"
                            />
                        </div>

                        <div class="address-form-grid">
                            <div class="input-container">
                                <label>Company or Name</label>

                                <input
                                    v-model.trim="shipmentInput.deliveryPickup.address.companyName"
                                    type="text"
                                    placeholder="Company or Name"
                                >
                            </div>

                            <div class="input-container">
                                <label>Attention</label>

                                <input
                                    v-model.trim="shipmentInput.deliveryPickup.address.attention"
                                    type="text"
                                    placeholder="Attention"
                                >
                            </div>

                            <div class="input-container full-width">
                                <label>Address *</label>

                                <input
                                    v-model.trim="shipmentInput.deliveryPickup.address.address1"
                                    type="text"
                                    placeholder="Address"
                                >
                            </div>

                            <div class="input-container full-width">
                                <label>Suite or Building</label>

                                <input
                                    v-model.trim="shipmentInput.deliveryPickup.address.address2"
                                    type="text"
                                    placeholder="Suite or Building"
                                >
                            </div>

                            <div class="input-container">
                                <label>City *</label>

                                <input
                                    v-model.trim="shipmentInput.deliveryPickup.address.city"
                                    type="text"
                                    placeholder="City"
                                >
                            </div>

                            <div class="input-container">
                                <label>State *</label>

                                <select
                                    v-model="shipmentInput.deliveryPickup.address.state"
                                >
                                    <option disabled value="">
                                        Select State
                                    </option>

                                    <option
                                        v-for="state in stateOptions"
                                        :key="state"
                                        :value="state"
                                    >
                                        {{ state }}
                                    </option>
                                </select>
                            </div>

                            <div class="input-container">
                                <label>Zip Code *</label>

                                <input
                                    v-model.trim="shipmentInput.deliveryPickup.address.zipCode"
                                    type="text"
                                    placeholder="Zip Code"
                                >
                            </div>

                            <div class="input-container">
                                <label>Phone</label>

                                <input
                                    v-model.trim="shipmentInput.deliveryPickup.address.phone"
                                    type="tel"
                                    placeholder="Phone"
                                >
                            </div>

                            <div class="input-container">
                                <label>Phone Extension</label>

                                <input
                                    v-model.trim="shipmentInput.deliveryPickup.address.phoneExt"
                                    type="text"
                                    placeholder="Extension"
                                >
                            </div>
                        </div>
                    </div>

                    <div class="form-section">
                        <div class="section-header">
                            <h2>Delivery Notifications</h2>
                        </div>

                        <RepeatableInputs
                            title="Delivery Emails"
                            placeholder="email@example.com"
                            type="email"
                            :items="shipmentInput.deliveryEmail"
                            @add="addArrayItem('deliveryEmail')"
                            @remove="removeArrayItem('deliveryEmail', $event)"
                        />

                        <div class="repeatable-section">
                            <div class="repeatable-header">
                                <h3>Delivery Emails</h3>

                                <button
                                    type="button"
                                    class="small-add-button"
                                    @click="addArrayItem('deliveryEmail')"
                                >
                                    + Add Email
                                </button>
                            </div>

                            <div
                                v-for="(email, index) in shipmentInput.deliveryEmail"
                                :key="`delivery-email-${index}`"
                                class="repeatable-row"
                            >
                                <input
                                    v-model.trim="shipmentInput.deliveryEmail[index]"
                                    type="email"
                                    placeholder="email@example.com"
                                >

                                <button
                                    type="button"
                                    class="remove-button"
                                    @click="removeArrayItem('deliveryEmail', index)"
                                >
                                    Remove
                                </button>
                            </div>
                        </div>

                        <div class="repeatable-section">
                            <div class="repeatable-header">
                                <h3>Delivery Phone Numbers</h3>

                                <button
                                    type="button"
                                    class="small-add-button"
                                    @click="addArrayItem('deliveryPhone')"
                                >
                                    + Add Phone
                                </button>
                            </div>

                            <div
                                v-for="(phone, index) in shipmentInput.deliveryPhone"
                                :key="`delivery-phone-${index}`"
                                class="repeatable-row"
                            >
                                <input
                                    v-model.trim="shipmentInput.deliveryPhone[index]"
                                    type="tel"
                                    placeholder="5551234567"
                                >

                                <button
                                    type="button"
                                    class="remove-button"
                                    @click="removeArrayItem('deliveryPhone', index)"
                                >
                                    Remove
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="form-section">
                        <div class="section-header">
                            <h2>Non-Delivery Notifications</h2>
                        </div>

                        <div class="repeatable-section">
                            <div class="repeatable-header">
                                <h3>Non-Delivery Emails</h3>

                                <button
                                    type="button"
                                    class="small-add-button"
                                    @click="addArrayItem('nonDeliveryEmail')"
                                >
                                    + Add Email
                                </button>
                            </div>

                            <div
                                v-for="(email, index) in shipmentInput.nonDeliveryEmail"
                                :key="`non-delivery-email-${index}`"
                                class="repeatable-row"
                            >
                                <input
                                    v-model.trim="shipmentInput.nonDeliveryEmail[index]"
                                    type="email"
                                    placeholder="email@example.com"
                                >

                                <button
                                    type="button"
                                    class="remove-button"
                                    @click="removeArrayItem('nonDeliveryEmail', index)"
                                >
                                    Remove
                                </button>
                            </div>
                        </div>

                        <div class="repeatable-section">
                            <div class="repeatable-header">
                                <h3>Non-Delivery Phone Numbers</h3>

                                <button
                                    type="button"
                                    class="small-add-button"
                                    @click="addArrayItem('nonDeliveryPhone')"
                                >
                                    + Add Phone
                                </button>
                            </div>

                            <div
                                v-for="(phone, index) in shipmentInput.nonDeliveryPhone"
                                :key="`non-delivery-phone-${index}`"
                                class="repeatable-row"
                            >
                                <input
                                    v-model.trim="shipmentInput.nonDeliveryPhone[index]"
                                    type="tel"
                                    placeholder="5551234567"
                                >

                                <button
                                    type="button"
                                    class="remove-button"
                                    @click="removeArrayItem('nonDeliveryPhone', index)"
                                >
                                    Remove
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="form-section">
                        <div class="section-header">
                            <h2>Additional Services</h2>
                        </div>

                        <div
                            v-if="!shipmentInput.service"
                            class="empty-service-message"
                        >
                            Select a service to view available additional services.
                        </div>

                        <div
                            v-else-if="additionalServiceOptions.length === 0"
                            class="empty-service-message"
                        >
                            No additional services are available for this service.
                        </div>

                        <div
                            v-else
                            class="repeatable-section"
                        >
                            <div class="repeatable-header">
                                <h3>Additional Services</h3>

                                <button
                                    type="button"
                                    class="small-add-button"
                                    @click="addAdditionalService"
                                >
                                    + Add Service
                                </button>
                            </div>

                            <div
                                v-for="(serviceCode, index) in shipmentInput.additionalServices"
                                :key="`additional-service-${index}`"
                                class="repeatable-row"
                            >
                                <select
                                    v-model="shipmentInput.additionalServices[index]"
                                >
                                    <option disabled value="">
                                        Select Additional Service
                                    </option>

                                    <option
                                        v-for="product in availableAdditionalServices(index)"
                                        :key="getAdditionalServiceValue(product)"
                                        :value="getAdditionalServiceValue(product)"
                                    >
                                        {{ getAdditionalServiceLabel(product) }}
                                    </option>
                                </select>

                                <button
                                    type="button"
                                    class="remove-button"
                                    @click="removeArrayItem('additionalServices', index)"
                                >
                                    Remove
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <loading-charts v-if="loadingData" />

                <div class="button-container">
                    <button
                        type="button"
                        class="print-button cancel-button"
                        :disabled="loadingData"
                        @click="closeShipmentPopup"
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        class="print-button create-button"
                        :disabled="loadingData"
                        @click="createShipment"
                    >
                        {{ loadingData ? "Creating..." : "Create Shipment" }}
                    </button>
                </div>
                <div v-if="(shippingLabelArray.length > 0)">
                    <pdf-label-renderer :urls="this.shippingLabelArray" :hideBarcode="hideBarcode"/>
                </div>
            </div>
        </div>

        <AlertUser
            v-if="toggleAlertBox"
            :message="alertMessage"
            @closeAlertBox="closeAlertBox"
        />
    </div>
</template>

<script>
import { API } from "aws-amplify";

import AlertUser from "../../../components/Popups/AlertUser.vue";
import LoadingCharts from "../../ShipmentDashboard/LoadingCharts.vue";
// import AWSAutoComplete from "../../AWSLocation/AddressAutoComplete.vue";
import AWSAutoComplete from "../../AWSLocation/EsriAddressAutoComplete.vue";

// Update this import path to match your generated mutation location.
import { createShipmentLREX } from "../../../graphql/mutations";
import PdfLabelRenderer from '../PdfLabelRenderer.vue';

const createEmptyAddress = () => ({
    companyName: "",
    attention: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipCode: "",
    phone: "",
    phoneExt: "",
    relevance: "",
    latitude: "",
    longitude: "",
    routeCode: ""
});

export default {
    name: "CreateShipmentPopup",

    props: {
        id: {
            type: [String, Number],
            default: null
        },

        jwtToken: {
            type: String,
            default: ""
        },

        AdminUser: {
            type: Boolean,
            default: false
        },

        InternalAdmin: {
            type: Boolean,
            default: false
        },

        defaultUsername: {
            type: String,
            default: ""
        },

        defaultAccountNo: {
            type: String,
            default: ""
        },

        defaultUserLocation: {
            default: {}
        }
    },

    components: {
        AlertUser,
        LoadingCharts,
        AWSAutoComplete,
        PdfLabelRenderer
    },

    computed: {
        serviceOptions() {
            const productFamilies = this.accountProducts
                .filter(product =>
                    product?.productFamily &&
                    product.additionalService !== true
                )
                .map(product => product.productFamily.trim());

            return [...new Set(productFamilies)].sort((a, b) =>
                a.localeCompare(b)
            );
        },

        displayedServiceOptions() {
            return this.overrideServiceOptions
                ? this.hardcodedServiceOptions
                : this.serviceOptions;
        },

        additionalServiceOptions() {
            if (!this.shipmentInput.service) {
                return [];
            }

            return this.accountProducts.filter(product =>
                product?.additionalService === true &&
                product?.productFamily === this.shipmentInput.service
            );
        }
    },

    data() {
        return {
            toggleAlertBox: false,
            accountProducts: [],
            shippingLabelArray: [],
            alertMessage: "",
            loadingData: false,
            gettingUserPreferences: false,
            stateOptions: [
                "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE",
                "DC", "FL", "GA", "HI", "ID", "IL", "IN", "IA",
                "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN",
                "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM",
                "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI",
                "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA",
                "WV", "WI", "WY"
            ],

            overrideServiceOptions: false,

            hardcodedServiceOptions: [
                "sameday",
                "priority",
                "standard",
                "saturday",
                "pickup"
            ],

            shipmentInput: {
                username: "",
                accountNo: "",
                service: "",
                shipmentID: null,
                ref1: "",
                ref2: "",
                ref3: "",
                ref4: "",
                ref5: "",
                description: "",
                deliveryInstructions: "",
                weight: 1,
                packageCount: 1,
                deliveryEmail: [""],
                deliveryPhone: [""],
                nonDeliveryEmail: [""],
                nonDeliveryPhone: [""],
                notify: [],
                additionalServices: [],
                deliveryPickup: {
                    address: createEmptyAddress()
                },
                serviceAddress: {
                    address: createEmptyAddress()
                }
            }
        };
    },

    watch: {
        "shipmentInput.service"(service, previousService) {
            this.shipmentInput.isPickup =
                String(service).toLowerCase() === "pickup";

            if (previousService && service !== previousService) {
                this.shipmentInput.additionalServices = [];
            }
        }
    },

    mounted() {
        this.shipmentInput.username = this.defaultUsername || "";
        this.shipmentInput.accountNo = this.defaultAccountNo || "";
        this.shipmentInput.deliveryPickup = this.defaultUserLocation;
        console.log(this.defaultUserLocation)
        this.GetAccountGraphQL();
    },

    methods: {
        closeAlertBox(toggleAlertBox) {
            this.toggleAlertBox = toggleAlertBox;
        },

        closeShipmentPopup() {
            this.$emit("closeAddressInfo", false);
            this.$emit("closeShipmentPopup", false);
        },

        showAlert(message) {
            this.alertMessage = message;
            this.toggleAlertBox = true;
        },

        addArrayItem(fieldName) {
            if (!Array.isArray(this.shipmentInput[fieldName])) {
                this.shipmentInput[fieldName] = [];
            }

            this.shipmentInput[fieldName].push("");
        },

        removeArrayItem(fieldName, index) {
            if (!Array.isArray(this.shipmentInput[fieldName])) {
                return;
            }

            this.shipmentInput[fieldName].splice(index, 1);
        },

        setServiceAddress(selectedAddress) {
            this.applySelectedAddress(
                this.shipmentInput.serviceAddress.address,
                selectedAddress
            );
            // Set delivery time windows from place data only if product hasn't already set them
            if (!this.shipmentInput.deliveryWindowStart && selectedAddress?.deliveryWindowStart) {
                this.shipmentInput.deliveryWindowStart = selectedAddress.deliveryWindowStart;
                this.shipmentInput.deliveryWindowEnd = selectedAddress.deliveryWindowEnd || "";
                this.shipmentInput.deliveryWindowLabel = selectedAddress.deliveryWindowLabel || "";
            }
        },

        setPickupAddress(selectedAddress) {
            this.applySelectedAddress(
                this.shipmentInput.deliveryPickup.address,
                selectedAddress
            );
            // Set pickup time windows from place data only if product hasn't already set them
            if (!this.shipmentInput.pickupWindowStart && selectedAddress?.pickupWindowStart) {
                this.shipmentInput.pickupWindowStart = selectedAddress.pickupWindowStart;
                this.shipmentInput.pickupWindowEnd = selectedAddress.pickupWindowEnd || "";
                this.shipmentInput.pickupWindowLabel = selectedAddress.pickupWindowLabel || "";
            }
        },

        swapAddresses() {
            const serviceAddress = JSON.parse(
                JSON.stringify(this.shipmentInput.serviceAddress)
            );

            const pickupAddress = JSON.parse(
                JSON.stringify(this.shipmentInput.deliveryPickup)
            );

            this.shipmentInput.serviceAddress = pickupAddress;
            this.shipmentInput.deliveryPickup = serviceAddress;
        },

        applySelectedAddress(targetAddress, selectedAddress) {
            targetAddress.latitude = selectedAddress?.latitude ?? "";
            targetAddress.longitude = selectedAddress?.longitude ?? "";
            targetAddress.address1 = selectedAddress?.address1 ?? "";
            targetAddress.address2 = selectedAddress?.address2 ?? "";
            targetAddress.zipCode = selectedAddress?.zipCode ?? "";
            targetAddress.city = selectedAddress?.city ?? "";
            targetAddress.state = selectedAddress?.state ?? "";
            targetAddress.relevance = selectedAddress?.relevance ?? "";
            targetAddress.routeCode = selectedAddress?.routeCode ?? "";
            if (selectedAddress?.placeCode) targetAddress.placeCode = selectedAddress.placeCode;
            if (selectedAddress?.serviceAddressType) targetAddress.serviceAddressType = selectedAddress.serviceAddressType;
        },

        customAddressToggle(toggleCustom) {
            if (!toggleCustom) {
                return;
            }

            this.showAlert(
                "Using a custom address may incur additional costs."
            );
        },

        cleanStringArray(values) {
            if (!Array.isArray(values)) {
                return [];
            }

            return values
                .map(value => String(value ?? "").trim())
                .filter(Boolean);
        },

        cleanPhoneArray(values) {
            return this.cleanStringArray(values).map(phone =>
                phone.replace(/\D/g, "")
            );
        },

        isValidEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        },

        validateShipmentInput() {
            const input = this.shipmentInput;
            const address = input.serviceAddress.address;

            if (!input.username) {
                return "Username is required.";
            }

            if (!input.accountNo) {
                return "Account number is required.";
            }

            if (!input.service) {
                return "Please select a service.";
            }

            if (!input.weight || Number(input.weight) <= 0) {
                return "Weight must be greater than zero.";
            }

            if (!address.address1) {
                return "The service address is required.";
            }

            if (!address.city || !address.state || !address.zipCode) {
                return "City, state, and zip code are required.";
            }

            if (input.service === "pickup") {
                const pickupAddress = input.deliveryPickup.address;

                if (
                    !pickupAddress.address1 ||
                    !pickupAddress.city ||
                    !pickupAddress.state ||
                    !pickupAddress.zipCode
                ) {
                    return "A complete pickup address is required.";
                }
            }

            const deliveryEmails = this.cleanStringArray(
                input.deliveryEmail
            );

            const nonDeliveryEmails = this.cleanStringArray(
                input.nonDeliveryEmail
            );

            const invalidEmail = [
                ...deliveryEmails,
                ...nonDeliveryEmails
            ].find(email => !this.isValidEmail(email));

            if (invalidEmail) {
                return `Invalid email address: ${invalidEmail}`;
            }

            const allPhones = [
                ...this.cleanPhoneArray(input.deliveryPhone),
                ...this.cleanPhoneArray(input.nonDeliveryPhone)
            ];

            const invalidPhone = allPhones.find(
                phone => phone.length !== 10
            );

            if (invalidPhone) {
                return "Phone numbers must contain exactly 10 digits.";
            }

            return null;
        },

        buildShipmentInput() {
            return {
                ...this.shipmentInput,

                weight: Number(this.shipmentInput.weight),

                packageCount: this.shipmentInput.packageCount
                    ? Number(this.shipmentInput.packageCount)
                    : null,

                isPickup: this.shipmentInput.service === "pickup",

                deliveryEmail: this.cleanStringArray(
                    this.shipmentInput.deliveryEmail
                ),

                deliveryPhone: this.cleanPhoneArray(
                    this.shipmentInput.deliveryPhone
                ),

                nonDeliveryEmail: this.cleanStringArray(
                    this.shipmentInput.nonDeliveryEmail
                ),

                nonDeliveryPhone: this.cleanPhoneArray(
                    this.shipmentInput.nonDeliveryPhone
                ),

                additionalServices: this.cleanStringArray(
                    this.shipmentInput.additionalServices
                ),

                notify: Array.isArray(this.shipmentInput.notify)
                    ? this.shipmentInput.notify
                    : []
            };
        },

        async GetAccountGraphQL() {
            this.gettingUserPreferences = true;

            const getAccountProducts = /* GraphQL */ `
                query GetAccountProducts($accountNo: String!) {
                    getAccount(accountNo: $accountNo) {
                        product {
                            productCode
                            serviceCode
                            productName
                            descriptionUI
                            productFamily
                            additionalService
                            price
                        }
                    }
                }
            `;

            try {
                const accountData = await API.graphql({
                    query: getAccountProducts,
                    variables: {
                        accountNo: this.shipmentInput.accountNo
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS"
                });

                this.accountProducts =
                    accountData?.data?.getAccount?.product ?? [];
            } catch (error) {
                console.error("Unable to get account products:", error);
                this.accountProducts = [];
            } finally {
                this.gettingUserPreferences = false;
            }
        },

        formatProductFamily(productFamily) {
            return String(productFamily ?? "")
                .replace(/[-_]/g, " ")
                .replace(/\b\w/g, character => character.toUpperCase());
        },

        addAdditionalService() {
            if (!Array.isArray(this.shipmentInput.additionalServices)) {
                this.shipmentInput.additionalServices = [];
            }

            this.shipmentInput.additionalServices.push("");
        },

        getAdditionalServiceValue(product) {
            return (
                product?.serviceCode ||
                product?.productCode ||
                product?.productName ||
                ""
            );
        },

        getAdditionalServiceLabel(product) {
            const name =
             product?.descriptionUI ||
                product?.productName ||
                product?.descriptionUI ||
                product?.description ||
                product?.serviceCode ||
                product?.productCode ||
                "Additional Service";

            const code =
                product?.serviceCode ||
                product?.productCode;

            if (code && !name.includes(code)) {
                return `${name} (${code})`;
            }

            return name;
        },

        availableAdditionalServices(currentIndex) {
            const selectedValues =
                this.shipmentInput.additionalServices ?? [];

            return this.additionalServiceOptions.filter(product => {
                const value = this.getAdditionalServiceValue(product);

                return (
                    selectedValues[currentIndex] === value ||
                    !selectedValues.includes(value)
                );
            });
        },

        async createShipment() {
            this.shippingLabelArray = []
            const validationError = this.validateShipmentInput();

            if (validationError) {
                this.showAlert(validationError);
                return;
            }

            this.loadingData = true;

            try {
                const input = this.buildShipmentInput();

                console.log("Creating shipment with input:", input);

                const response = await API.graphql({
                    query: createShipmentLREX,
                    variables: {
                        input
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS"
                });

                const createdShipment =
                    response?.data?.createShipmentLREX;

                if (!createdShipment?.shipmentID) {
                    throw new Error(
                        "The shipment was not created successfully."
                    );
                }

                console.log(
                    "Shipment created:",
                    createdShipment
                );

                this.showAlert(
                    `Shipment ${createdShipment.shipmentID} created successfully.`
                );

                this.shippingLabelArray.push(createdShipment.labelURL)

                this.$emit("shipmentCreated", createdShipment);
            } catch (error) {
                console.error(
                    "Error creating shipment:",
                    error
                );

                this.showAlert(
                    error?.errors?.[0]?.message ||
                    error?.message ||
                    "Error creating shipment."
                );
            } finally {
                this.loadingData = false;
            }
        }
    }
};
</script>

<style scoped>
input,
select,
textarea {
    width: 100%;
    padding: 10px;
    margin-top: 5px;
    font-size: 15px;
    border: 1px solid rgba(0, 0, 0, 0.336);
    border-radius: 15px;
    outline: none;
    box-sizing: border-box;
}

textarea {
    min-height: 90px;
    resize: vertical;
}

.main-container-shipmentinfo {
    position: fixed;
    inset: 0;
    z-index: 1000;
    width: 100%;
    height: 100vh;
    padding: 20px 0;
    overflow-y: auto;
    box-sizing: border-box;
    background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.30),
        rgba(0, 0, 0, 0.0)
    );
}

.inner-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    min-height: 100%;
    flex-direction: column;
}

.swap-address-container {
    display: flex;
    justify-content: center;
    padding: 0 10px 14px;
}

.override-option {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 8px 0 10px;
    font-size: 14px;
    font-weight: 500;
    color: #555;
    cursor: pointer;
    user-select: none;
}

.override-option input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin: 0;
    cursor: pointer;
    accent-color: #3b82f6; /* Optional - blue checkbox */
}

.override-option input[type="checkbox"]:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.override-option:has(input:disabled) {
    cursor: not-allowed;
    opacity: 0.7;
}

.swap-address-button {
    padding: 9px 18px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    background-color: #32ccfe;
    border: none;
    border-radius: 999px;
    cursor: pointer;
    transition:
        background-color 0.25s ease,
        transform 0.2s ease,
        box-shadow 0.25s ease;
}

.swap-address-button:hover {
    background-color: #2dbbeb;
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.swap-address-button:active {
    transform: translateY(0);
    box-shadow: none;
}

.swap-address-button:disabled {
    background-color: #d5d5d5;
    color: #777777;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.confirm-container-main {
    position: relative;
    display: flex;
    margin-top: 5px;
    flex-direction: column;
    width: min(950px, 94%);
    max-height: calc(100vh - 40px);
    overflow: hidden;
    background-color: #ffffff;
    border-radius: 25px;
    box-sizing: border-box;
    box-shadow:
        rgba(0, 0, 0, 0.05) 0 54px 55px,
        rgba(0, 0, 0, 0.12) 0 -12px 30px,
        rgba(0, 0, 0, 0.12) 0 4px 6px;
}

.close-shipment-info-container {
    position: sticky;
    top: 0;
    z-index: 20;
    display: flex;
    justify-content: flex-end;
    padding: 8px 15px 0;
    background-color: #ffffff;
}

.close-shipment-info {
    width: 30px;
    height: 30px;
    cursor: pointer;
    border-radius: 999px;
}

.close-shipment-info:hover {
    background-color: #e4e4e4;
}

.confirm-header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px 12px;
}

.confirm-header-container img {
    width: 40px;
}

.package-details-header {
    width: fit-content;
    margin: 0;
    padding: 10px 18px;
    color: #ffffff;
    background-color: #32ccfe;
    border-radius: 50px;
}

.inner-overflow-container {
    padding: 10px;
    overflow-y: auto;
    border-top: 1px solid #d5d5d5;
    border-bottom: 1px solid #d5d5d5;
}

.form-section {
    padding: 15px;
    margin-bottom: 14px;
    background-color: #f5f5f5;
    border-radius: 20px;
    box-shadow: rgb(0 0 0 / 12%) 0 1px 8px;

    position: relative;
    overflow: visible;
}

.section-header {
    display: flex;
    align-items: center;
    width: fit-content;
    padding: 6px 14px;
    margin-bottom: 12px;
    background-color: #e4e4e4;
    border-radius: 999px;
}

.section-header h2 {
    margin: 0;
    font-size: 19px;
}

.form-grid,
.address-form-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.input-container {
    display: flex;
    flex-direction: column;
    flex: 1 1 calc(50% - 6px);
    min-width: 280px;
}

.full-width,
.auto-complete-container {
    flex: 1 1 100%;
}

.input-container label {
    margin-left: 7px;
    font-weight: bold;
}

.full-width {
    grid-column: 1 / -1;
}

.auto-complete-container {
    margin-bottom: 12px;
    position: relative;
    width: 100%;
    overflow: visible;
    z-index: 20;
}

.checkbox-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 15px;
}

.checkbox-container {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 14px;
    background-color: #ffffff;
    border-radius: 15px;
    cursor: pointer;
}

.checkbox-container input {
    width: auto;
    margin: 0;
}

.repeatable-section {
    padding: 12px;
    margin-bottom: 12px;
    background-color: #ffffff;
    border-radius: 15px;
}

.repeatable-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.repeatable-header h3 {
    margin: 0;
}

.repeatable-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 8px;
}

.small-add-button,
.remove-button {
    padding: 7px 13px;
    border: none;
    border-radius: 999px;
    cursor: pointer;
    white-space: nowrap;
}

.small-add-button {
    background-color: #32ccfe;
    color: #ffffff;
}

.remove-button {
    background-color: #e4e4e4;
}

.button-container {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 14px 20px;
}

.print-button {
    width: fit-content;
    padding: 8px 18px;
    border: none;
    border-radius: 999px;
    cursor: pointer;
}

.cancel-button {
    background-color: #e4e4e4;
}

.create-button {
    background-color: #33f18a;
}

.create-button:hover {
    background-color: #31d77b;
}

.print-button:disabled {
    cursor: not-allowed;
    opacity: 0.65;
}

@media only screen and (max-width: 820px) {
    .main-container-shipmentinfo {
        padding: 10px 0;
    }

    .confirm-container-main {
        width: 96%;
        max-height: calc(100vh - 20px);
        border-radius: 18px;
    }

    .form-grid,
    .address-form-grid {
        grid-template-columns: 1fr;
    }

    .full-width {
        grid-column: auto;
    }
}

@media only screen and (max-width: 530px) {
    .repeatable-header,
    .repeatable-row {
        align-items: stretch;
        flex-direction: column;
    }

    .button-container {
        flex-direction: column-reverse;
    }

    .print-button {
        width: 100%;
    }

    .package-details-header {
        font-size: 1.3em;
    }
}
</style>